import React from 'react';
import { THEME_COLORS } from '../../../../common/themes';

const TBody=(props)=>{

    const { bodyProps, getRowProps } = props;
    const { getTableBodyProps, rows, prepareRow } = bodyProps;

    return (
      <div {...getTableBodyProps()} className="body">
      {rows.map((row) => {

        prepareRow(row);

        return (
          <div {...row.getRowProps(getRowProps(row))} className="tr">
            {row.cells.map((cell) => (
              <div {...cell.getCellProps([
                {
                  style:cell.column.style,
                },
                ...getRowProps(row)
              ])} className="td">
                {cell.render('Cell')}
              </div>
            ))}
          </div>
        );
      })}
    </div>
    )
}

export default TBody;
